import React from "react"
import { server } from "../api"

export default function () {
  return <iframe width="100%" style={{ height: '100vh'}} src={`${server}/ssr/custom-prompts`} frameBorder="0"></iframe>
}
